module.exports = __webpack_public_path__ + "media/svg/sr-50f95040.svg";